<template>
  <!-- narrow-first: the 360px sidebar leaves the header cramped until about 1200px -->
  <header
    class="tw:flex tw:flex-wrap tw:items-center tw:justify-end tw:gap-3 tw:border-b tw:border-border tw:bg-surface tw:px-4 tw:py-3 tw:md:justify-between tw:md:px-8 tw:md:py-4 tw:wizard:flex-nowrap tw:wizard:gap-6 tw:wizard:px-18 tw:wizard:py-5">
    <!-- hidden below 768px, where the progress bar renders the same string -->
    <span
      class="tw:hidden tw:text-13 tw:font-medium tw:text-muted tw:md:block"
      role="status"
      aria-live="polite"
      data-testid="reg-breadcrumb">
      {{ breadcrumb }}
    </span>

    <span class="tw:flex tw:min-w-0 tw:flex-wrap tw:items-center tw:gap-3 tw:wizard:flex-nowrap tw:wizard:gap-5">
      <LanguageSelect class="tw:w-60" data-testid="reg-language" />

      <span v-if="showSignIn" class="tw:text-13 tw:text-gray-600 tw:wizard:whitespace-nowrap">
        {{ $t('registration.header.have_account') }}
        <RouterLink :to="{ name: 'login' }" data-testid="reg-signin">{{ $t('sign_in') }}</RouterLink>
      </span>
    </span>
  </header>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router';

import LanguageSelect from '@/components/generic/LanguageSelect.vue';

interface Props {
  breadcrumb: string;
  /** sign-in is only offered on the first step */
  showSignIn: boolean;
}

defineProps<Props>();
</script>
